import React, { useContext } from "react";

import {
    AccountBalance,
    AirplaneTicket,
    AirplanemodeActive,
    AirportShuttle,
    AssignmentInd,
    DirectionsBoat,
    DirectionsBus,
    DirectionsCar,
    DirectionsTransit,
    DirectionsWalk,
    EscalatorWarning,
    Flight,
    Groups,
    Hail,
    Home,
    House,
    Launch,
    LocalTaxi, Train,
    Tram, Visibility
} from "@material-ui/icons";

import Box from "@material-ui/core/Box";

import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";


import { Button, Slide, Tooltip } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import { MailOutline, ModeOfTravel, PhoneIphone, Public } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";

import { cLog, cWarn } from "../components/igtm/CustomLogger";
import axios from "../utils/axios";
import { BookingDialogueContext } from "../components/igtm/BookingDialoguesContext";
import BookingTimeline from "../components/igtm/BookingTimeline";

import { BookingConfigContext } from "./BookingConfigContext";
import { BrandContext } from "./BrandContext";
import { SelectorContext } from "./SelectorContext";




export const formatAddressToString = (address) => {

    if(address){
        const line1Parts = [];

        const {houseNumber='',houseName='',street='',town='',postcode=''} = address;

        if(houseNumber){
            line1Parts.push(houseNumber);
        }
        if(houseName){
            line1Parts.push(houseName);
        }
        if(street){
            line1Parts.push(street);
        }
        const line1 = line1Parts.join(' ');

        const addr = [];
        if(line1){
            addr.push(line1);
        }
        
        if(town){
            if(town !== 'null'){
                addr.push(town);
            }
        }
        
        if(postcode){
            addr.push(postcode);
        }
        
        return addr.join(', ');
    }
    return '';
};

export const formatAddressToStringShort = (address) =>  (
    `${address.houseNumber} ${address.houseName} ${address.street}, ${address.town}`
);


export const stringAvatar = (name) => {
    const initials = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
    return {
        children: initials,
    };
}

export const converToMiles = (meters) => {
    const miles = meters/1609;
    let output = 0;
    if(miles < 10){
        output = Math.round(miles*10)/10;
    }
    else{
        output = Math.round(miles);
    }
    return output;
}

export const iconMap = {
    'AirportShuttle':<AirportShuttle/>,
    'LocalTaxi':<LocalTaxi/>,
    'DirectionsCar':<DirectionsCar/>,
    'Train':<Train/>,
    'DirectionsWalk':<DirectionsWalk/>,
    'DirectionsBoat':<DirectionsBoat/>,
    'House':<House/>,
    'Home':<Home/>,
    'Flight':<Flight/>,
    'Flying':<AirplaneTicket/>,
    'AccountBalance':<AccountBalance/>,
    'AirplanemodeActive':<AirplanemodeActive/>,
    'DirectionsTransit':<DirectionsTransit/>,
    'DirectionsBus':<DirectionsBus/>,
    'OtherMode':<ModeOfTravel/>,
    'PublicTransport':<Tram/>,
    'Open': <Launch/>,
    'Travel':<Visibility />,
    'OwnTaxi':<Hail/>,
    'Groups':<Groups/>,
    'InPerson':<EscalatorWarning/>,
    Public:<Public/>
};


export const getDestinationTypesMap = (context) => context.destinationTypesMap;

export const getDestinationModesMap = (context) => context.travelModesMap;


export const getFriendlyAddress = (point) => {
    
    try{
        if(point.type === 'internationalFlight'){
            if('flightData' in point){
                if('direction' in point.flightData){
                    if(point.flightData.direction === 'incoming'){
                        return `${formatTime(point.flightData.arrivalTime.date)} at ${point.flightData.arrivalAirport}${point.flightData.arrivalTerminal ? `, Terminal ${point.flightData.arrivalTerminal}` : ''}`;
                    }
                }
                return `${formatTime(point.flightData.departureTime.date)} at ${point.flightData.departureAirport}${point.flightData.departureTerminal ? `, Terminal ${point.flightData.departureTerminal}` : ''}`;
            }
            return '';
        }
        if(point.type === 'schoolLocation'){
            const {
                address:{
                    name=''
                }
            } = point;
            return name;
        }
        if(point.type === 'airport'){
            const {
                stationAddress:{
                    name=''
                } = {},
                departing=false,
                flightData:{
                    arrivalAirport='',
                    departureAirport='',
                    departureTerminal='',
                    arrivalTerminal=''
                } = {
                    arrivalAirport:'',
                    departureAirport:'',
                    departureTerminal:'',
                    arrivalTerminal:''
                }
            } = point;
            // cLog(point);
            // cLog(name);
            if(departing && departureAirport !== ''){
                return `${departureAirport}${departureTerminal ? `, Terminal ${departureTerminal}` : ''}`;
            }
            if(!departing && arrivalAirport !== ''){
                return `${arrivalAirport}${arrivalTerminal  ? `, Terminal ${arrivalTerminal}` : ''}`;
            }

            return name;
        }
        if(point.type === 'busStation'){
            return point.stationAddress.name;
        }
        if(point.type === 'trainStation'){
            return `${point.stationAddress.Name} (${point.stationAddress.shortName})`;
        }
        if(point.type === 'otherInternationalTravel'){
            return point.additionalAddress.travel_hub_name;
        }
        if(point.type === 'schoolCoachStop'){
            return point.stationAddress.name;
        }
        if(point.friendlyAddress){
            return point.friendlyAddress;
        }
        return '';
    }
    catch(e){
       console.log(e);
       // console.log(point);
        return '';
    }
}

function isIsoDate(str) {
    if (typeof str === 'string' || str instanceof String){
        if ((str.indexOf('+') > -1) && (str.indexOf('z') > -1)){
            return true;
        }
    }
    else{
        return true;
    }

    return false;

}


export const  makeLocalDateObject = (dateString) => {
    const myDate = new Date();
    const dateParts = dateString.split('T');
    const dateBits = dateParts[0].split('-');
    myDate.setFullYear(dateBits[0]);
    myDate.setDate(dateBits[2]);
    myDate.setMonth(Number(dateBits[1])-1);
    return myDate;
}

export const getComponentsFromUtcDate = (dateString) => {
    try{
        let dateParts = [];
        if(dateString.includes('T')){
            dateParts = dateString.split('T');
        }
        else{
            dateParts = dateString.split(' ');
        }
        if(dateParts.length > 0){
            const dateBits = dateParts[0].split('-');
            const timeBits = dateParts[1].split(':');
            return {
                year:dateBits[0],
                month:dateBits[1],
                day:dateBits[2],
                hours:timeBits[0],
                mins:timeBits[1],
                secs:timeBits[2]
            }
        }
    }
    catch(e){
        cWarn(e);   
    }
    return {
        year:'',
        month:'',
        day:'',
        hours:'',
        mins:'',
        secs:''
    }
    
    
}


export const formatTime = (time) => {

    if(isIsoDate(time)) {
        let modTime = time;
        if (typeof modTime === 'string' || modTime instanceof String) {
            modTime = utcToZonedTime(modTime, 'Europe/London');
        }
        cLog(time,modTime);
        try {
            const output = format(modTime, 'HH:mm', {timeZone: 'Europe/London'});
            return output;
        } catch (e) {
            // cWarn(e);
            return '';
        }
    }
    else{
        // cLog('no iso time',time);
        try {
            const output = format(new Date(time), 'HH:mm', {timeZone: 'Europe/London'});
            return output;
        }
        catch (e){
            return '';
        }
    }
}



export const getShortFriendlyAddress = (point) => {
    try{
        if(point.type === 'home'){
            return point.address.town;
        }
        return getFriendlyAddress(point);
    }
    catch(e){
       // console.log(e);
       // console.log(point);
        return '';
    }
}

/* eslint-disable */
export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */


export const StaffApprovalIcon = (props) => {
    const selectorContext = useContext(SelectorContext);
    
    let canApprove = false;
    if(selectorContext){
        if(selectorContext.data){
            canApprove = selectorContext.data.hasApprovalRight;
        }
    }

    let housemClass = 'unapproved';
    let housemTip = 'Awaiting staff approval';

    const {booking} =  props;

    if(booking) {

        const{
            housemApprovedDate:housemApproval,
            parentApprovedDate:parentApproval,
            housemApproved={}        } =  booking;
        

        let housemFullName = '';
        if(housemApproved){
            const{
                firstName:housemFirstName='',
                lastName:housemLastName=''
            } = housemApproved;
            housemFullName = `${housemFirstName} ${housemLastName}`.trim();
        }

        
        if (housemApproval) {
            housemClass = 'partApproved';
            housemTip = `Staff approved by ${housemFullName} on ${formatDate(housemApproval)} at ${formatTime(housemApproval)}`;
        }
        if (housemApproval && parentApproval) {
            housemClass = 'fullyApproved';
        }
        return (
            <Tooltip title={housemTip}>
                <IconButton size="small" className={canApprove ? `${housemClass} iconButton` : housemClass} onClick={canApprove ? props.approvalCallback : ()=>{}}>
                    <AssignmentInd/>
                </IconButton>
            </Tooltip>
        );
    }
    return <></>;
}


export const getPassengerFromStb = (stb) => {
    const {
        student = null,
        contact = null,
        staff = null
    } = stb;
    const output = {};
    if(student){
        const {
            firstName='',
            lastName='',
            email='',
            metaData=null,
            id
        } = student;

        let mobile = '';
        if(metaData){
            ({mobile=''} = metaData);
        }

        output.passenger = student;
        output.type = 'student';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            email,
            mobile
        };
        return output;
    }
    if(contact){

        const {
            firstName='',
            lastName='',
            email='',
            mobile='',
            id
        } = contact;

        output.passenger = contact;
        output.type = 'contact';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            email,
            mobile
        };
        return output;
    }
    if(staff){

        const {
            firstName='',
            lastName='',
            email='',
            mobile='',
            id
        } = staff;

        output.passenger = staff;
        output.type = 'staff';
        output.id = id;
        output.contacts = {
            firstName,
            lastName,
            email,
            mobile
        };
        return output;
    }
    return null;
}

export const addContactToMenuOptions = (data,menuOptions) => {
    const{
        mobile='',
        email = '',
    } = data;
    if(mobile){
        menuOptions.push(
            {
                text: mobile,
                iconComponent:<PhoneIphone/>,
                to:`tel:${mobile}`,
                branded: true
            }  
        );
    }
    if(email){
        menuOptions.push(
            {
                text: email,
                iconComponent:<MailOutline/>,
                to:`mailto:${email}`,
                branded: true
            }  
        );
    }
    return menuOptions;
}







export const formatDate = (date,options) => {
    if(date){
        let settings = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            timeZone: "Europe/London",
        }
        if(options){
            settings = options
        }

        try{
            return new Intl.DateTimeFormat("en-GB",settings).format(new Date(date));
        }
        catch(e){
           // console.log(date);
           // console.log(e);
            return '';
        }

    }
    return '';
}

export const formatDateUTC = (date) => {
    if(date){
        return new Intl.DateTimeFormat("en-GB", {hour: "numeric", minute: "numeric", timeZone: "UTC"}).format(new Date(date));
    }
    return '';
}

export const outputCurrency = (str) => {
    if(str > 0){
        return  (new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })).format(str);
    }
    return '';
}

export const outputCurrencyPence = (str) => {
    if(str > 0){
        return  (new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(str);
    }
    return '';
}


export const formatDateCatchTimezone = (date) => {
    if(date){
        try{
            const testDate = new Date(date);
            if(testDate.getHours() === 23){
                testDate.setDate(testDate.getDate()+1);
            }
            return new Intl.DateTimeFormat("en-GB", {year: "numeric", month: "short", day: "2-digit"}).format(testDate);
        }
        catch(e){
           // console.log(date);
           // console.log(e);
            return '';
        }

    }
    return '';
}

export const formatDateCatchTimezoneShort = (date) => {
    if(date){
        try{
            const testDate = new Date(date);
            
            return new Intl.DateTimeFormat("en-GB", {year: "2-digit", month: "short", day: "2-digit"}).format(testDate);
        }
        catch(e){
            cWarn(e);
            return '';
        }

    }
    return '';
}


export const formatDateToUKTimeZone = (dateString,dateFormat,timeZone) => {
    try {
        let dFormat = dateFormat;
        if(dFormat === undefined){
            dFormat = 'dd MMM yyyy, HH:mm';
        }

        let tZone = timeZone;
        if(tZone === undefined){
            tZone = 'Europe/London';
        }
        // Parse the date string into a Date object
        const date = new Date(dateString);

        // Convert the date to the Europe/London timezone
        const londonTime = utcToZonedTime(date, tZone);

        // Format the date into a readable string for the UK
        return format(londonTime,dFormat, { timeZone: tZone});
    } catch (e) {
        console.warn('Error formatting date:', e);
        return '';
    }
};

export const isLegFulfilled = (leg) => {
    const {
            mode,
            transportData:{selfBook}={selfBook:'0'}
        } = leg;
    let fulfilled = false;
    let fulfilledMatters = false;
    if(mode === 'bookMeATaxi'){
        fulfilledMatters = true;
        if(selfBook === '0'){
            fulfilled = true;
        }
    }
    if(mode === 'schoolCoach'){
        fulfilledMatters = true;
        fulfilled = true;
    }
    return {
        fulfilledMatters,
        fulfilled
    }
}







export const ApproveDialogue = (props) => {
    const brandContext = useContext(BrandContext);
    const theme = useTheme();
    const fullScreenDialogues = useMediaQuery(theme.breakpoints.down('md'));
    const context = useContext(BookingDialogueContext);
    const bookingConfig = useContext(BookingConfigContext);
    return (
        <Dialog
            fullScreen={fullScreenDialogues}
            open={context.showStaffApprovalDialogue}
            onClose={()=>{context.setState({showStaffApprovalDialogue:false})}}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {brandContext.textContent.approveBookingDialogueTitle}
            </DialogTitle>
            <DialogContent>
                {brandContext.textContent.approveBookingDialogueHelperText && <DialogContentText>{brandContext.textContent.approveBookingDialogueHelperText}</DialogContentText>}
                <BookingTimeline
                    booking={context.approvalBooking}
                    textContent={brandContext.textContent}
                    modeTypesMap={bookingConfig.travelModesMap}
                    destinationTypesMap={bookingConfig.destinationTypesMap}
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={()=>{context.setState({showStaffApprovalDialogue:false})}}>
                    Disagree
                </Button>
                <Button onClick={() => {context.approveBooking(props.callBack)}} autoFocus>
                    Agree
                </Button>
            </DialogActions>
        </Dialog>
    );
}


export const BookingDetailDialogue = () => {
    const brandContext = useContext(BrandContext);

    const context = useContext(BookingDialogueContext);
    const bookingConfig = useContext(BookingConfigContext);
    
    return (
        <Dialog
            fullWidth
            open={context.showDetailDialogue}
            onClose={()=>{context.setState({showDetailDialogue:false})}}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {brandContext.textContent.bookingDetailDialogueTitle}
            </DialogTitle>
            <DialogContent>
                {brandContext.textContent.bookingDetailDialogueHelperText && <DialogContentText>{brandContext.textContent.bookingDetailDialogueHelperText}</DialogContentText>}
                {context.showDetailDialogue &&
                    <BookingTimeline
                        booking={context.detailBooking}
                        textContent={brandContext.textContent}
                        modeTypesMap={bookingConfig.travelModesMap}
                        destinationTypesMap={bookingConfig.destinationTypesMap}
                    />
                }
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={()=>{context.setState({showDetailDialogue:false})}}>
                    {brandContext.textContent.closeButton}
                </Button>
            </DialogActions>
        </Dialog>
    );
}










export const formatCurrency = (value) => {
    const newVal = (new Intl.NumberFormat('en-GB', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })).format(value.toString().replace(/[^\d.-]/g, ''));
    return newVal;
}


export const formatTimeWithIntegers = (time,hoursMin) => {

    try {

        const utcDate = zonedTimeToUtc(time, 'Europe/London');

        if('hours' in hoursMin){
            utcDate.setHours(hoursMin.hours);
        }
        if('mins' in hoursMin){
            utcDate.setMinutes(hoursMin.mins);
        }

        const output = new Intl.DateTimeFormat("en-GB", {
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Europe/London'
        }).format(utcDate);

        return output;
    }
    catch(e){
        console.warn(e);
        return '';
    }
}

export const hoursMinFromTime = (tTime) => {
    if( typeof tTime === 'string'){
        tTime = new Date(tTime);
    }

    const hoursMin = {
        hours:tTime.getHours(),
        mins:tTime.getMinutes()
    };

    return hoursMin;
}

export const hoursMinToTimeString = (hoursMin) => {

    const hours = String(hoursMin.hours).padStart(2,'0');
    const mins = String(hoursMin.mins).padStart(2,'0');
    return `${hours}:${mins}`;
}



export const formatTimeForceTimeZone = (time) => {
    
    try {
        const date = new Date(time);       
        let hours = '';
        let mins = '';
        if(time.includes('+')){
            hours = String(date.getHours() + (date.getTimezoneOffset()/60)).padStart(2,'0');
            mins = String(date.getMinutes()).padStart(2,'0');
        }
        else{
            hours = String(date.getHours()).padStart(2,'0');
            mins = String(date.getMinutes()).padStart(2,'0');
        }
        return `${hours}:${mins}`;

    }
    catch(e){
        // console.warn(e);
        return '';
    }
}






export const GetDistantLabel = (props) => {

    const {booking} = props;    
    if(booking){
        try{
            if(booking.bookingJson.direction === 'outgoing'){
                if(booking.bookingJson.destination.destination.type === 'inPersonCollection'){
                    return 'Collect in person';
                }
                return getFriendlyAddress(booking.bookingJson.destination.destination);
            }
            if(booking.bookingJson.origin.destination.type === 'inPersonDropoff'){
                return 'Dropoff in person';
            }
            return getFriendlyAddress(booking.bookingJson.origin.destination);
        }
        catch(e){
            console.warn(e);
            return null;
        }
    }
    return null;

}

export const BookingCell = (props) => {
    
    const {additionalClass='', studentToBooking={}} = props;
    const {booking={}} = studentToBooking;
    if(!booking){
        return null;
    }
    const {isCancelled = false} = booking;

    const {
        maxWidth=180,
        truncate=true
    } = props;

    return (
        <Box component="div" className={`${additionalClass} ${isCancelled && ' bookingCancelled '} bookingBox` }>
            {truncate ?
                <Box className="innerBookingBox" sx={{maxWidth}} >
                    {props.children}
                </Box>
                :
                <Box >
                    {props.children}
                </Box>
            }
        </Box>
    );
}


export const processAccademicYearToList = (travelDatesData) =>{
    let defDate = '';
    const windowOptions = [];
    const now = new Date();
    for(let i=0; i<travelDatesData.length; i+=1){
        const accademicYear = travelDatesData[i];
        const {
             yearStart,
             yearEnd,
             id:yearId,
             accademicYearsToTravelDays:startEndTravelDates=[],
             schoolHolidays=[],
         } = accademicYear;
        
        const yearLabel = `${getComponentsFromUtcDate(yearStart).year.substr(2)}/${getComponentsFromUtcDate(yearEnd).year.substr(2)}`;
        for(let j=0; j<startEndTravelDates.length; j+=1){
             const {travelDate} = startEndTravelDates[j];
             const {directionType:{id:directionTypeId},travelDate:tDate} = travelDate;
             if(directionTypeId === 1){
                 windowOptions.push({
                     label:`${yearLabel} - Year Start`,
                     value:`acYearStart_${yearId}`,
                     date:tDate
                });
                break;
             }
        }

        for(let j=0; j<schoolHolidays.length; j+=1){
             const{
                 name:holidayName,
                 id:holidayId,
                 schoolHolidayToTravelDates:holidayTravelDates=[],
             } = schoolHolidays[j];

             if(holidayTravelDates.length > 0){
                 const firstTravelDate = holidayTravelDates[0];
                 const {travelDate:{travelDate:tDate}} = firstTravelDate;
                 windowOptions.push({
                     label:`${yearLabel} - ${holidayName}`,
                     value:`holiday_${holidayId}`,
                     date:tDate
                });
             }

             
        }

        for(let j=0; j<startEndTravelDates.length; j+=1){
             const {travelDate} = startEndTravelDates[j];
             const {directionType:{id:directionTypeId},travelDate:tDate} = travelDate;
             
             if(directionTypeId === 2){
                 windowOptions.push({
                     label:`${yearLabel} - Year End`,
                     value:`acYearEnd_${yearId}`,
                     date:tDate
                 });
                 break;
             }
         }


     }
     

     for(let i=0; i<windowOptions.length; i+=1){
         if(!defDate){
             if(now < new Date(windowOptions[i].date)){
                 defDate = windowOptions[i].value;
             }
         }
     }     
     return {windowOptions,defDate};

}


export const approveBookingInstant = (id,callBack) => {
    const apiPath = `${process.env.REACT_APP_API_URL}/staffapprovebooking`;
    axios.post(apiPath,{
        bookingId:id
    },{
        timeout: 300000,
        withCredentials:true
    }).then(() => {
        if(callBack){
            callBack();
        }
    }).catch(err => {
       cWarn(err);
    });
}